import React, { Component } from "react";

class Nav extends Component {
  render() {
    return (
      <div>
        <nav className="white" role="navigation">
          <div className="nav-wrapper container">
            <a id="logo-container" href="#" className="brand-logo">
              <img className="logo" alt="logo" src={process.env.PUBLIC_URL + "/moana-support-side.svg"} />
            </a>
            <ul className="right hide-on-med-and-down">
              <NavLinks />
            </ul>
            <ul id="nav-mobile" className="side-nav">
              <NavLinks />
            </ul>
            <a href="#" data-activates="nav-mobile" className="button-collapse">
              <i className="material-icons">menu</i>
            </a>
          </div>
        </nav>
      </div>
    );
  }
}
const NavLinks = () => (
  <div>
    <li>
      <a href="#about">About</a>
    </li>
    <li>
      <a href="#contact">Contact Us</a>
    </li>
    <li>
      <a href="#services">Services</a>
    </li>
    {/* <li>
      <a href="#">Career</a>
    </li>
    <li>
      <a href="#">Admin</a>
    </li> */}
  </div>
);

export default Nav;
